// extracted by mini-css-extract-plugin
export default {"btnRetorno":"BtnRetorno_btnRetorno__5KjBE"};